import { Flex, Heading } from "@chakra-ui/react";
import { FunctionComponent, ReactElement } from "react";

interface FatalErrorPageProps {}

const FatalErrorPage: FunctionComponent<FatalErrorPageProps> = (props: FatalErrorPageProps): ReactElement => {
	return (
		<Flex flexDirection="column" justifyContent="center" alignItems="center" m={10} w="100%">
			<Heading mb="5" textAlign="center" color="red">
				A Fatal Error Occurred
			</Heading>
		</Flex>
	);
};

export default FatalErrorPage;
